import { Component } from "@angular/core";
import { NavController } from "ionic-angular";
import { Events } from "ionic-angular";
import { WhiskyDB } from "../../data/db";
import { Whisky } from "../../data/whisky";
import { NewWhiskySelectPage } from "../newWhiskySelect/newWhiskySelect";
import { AlertController } from "ionic-angular/components/alert/alert-controller";
import { NavParams } from "ionic-angular/navigation/nav-params";
//import { Camera, CameraOptions } from '@ionic-native/camera';
import { Camera, CameraResultType } from '@capacitor/camera';
import { ViewController } from "ionic-angular/navigation/view-controller";
import { ToastController } from "ionic-angular/components/toast/toast-controller";
import { ModalController } from "ionic-angular/components/modal/modal-controller";


@Component({
  selector: "page-newWhisky",
  templateUrl: "newWhisky.html"
})

export class NewWhiskyPage {
  newName: string = "";
  distillery: string = "";
  rating: string = "";
  shelf1: string = "";
  shelf2: string = "";
  bottler: string = "";
  region: string = "";
  SWMS: string = "";
  image: string = "";
  imageChanged: boolean = false;

  select = false;

  // for dropdowns
  ratings: any[];
  shelves: any[];
  distilleries: any[];
  newWhiskySelect: any;

  title: string = "New";
  orig: Whisky = null;

  onSelect() {
    this.select = true;
    //this.navCtrl.push(this.newWhiskySelect, {title: "Distillery"});
    let modal = this.modalCtrl.create(this.newWhiskySelect, {title: "Distillery"});
    modal.present();
  }

  onSelectBottler() {
    this.select = true;
    //this.navCtrl.push(this.newWhiskySelect, {title: "Bottler"});
    let modal = this.modalCtrl.create(this.newWhiskySelect, {title: "Bottler"});
    modal.present();

  }

  getItems(ev: any) {
    let val = ev.target.value;

    if (val && val.trim() != "") {
      console.log("Filter=" + val);
      this.distilleries = WhiskyDB.distilleries.filter(item => {
        return (
          item.Distillery.toLowerCase().indexOf(val.toLowerCase()) > -1 ||
          item.Region.toLowerCase().indexOf(val.toLowerCase()) > -1
        );
      });
    } else {
      // Reset items back to all of the items
      this.distilleries = WhiskyDB.distilleries;
    }
  }

  getBottlers() {
    return WhiskyDB.bottlers;
  }

  constructor(
    public navCtrl: NavController,
    private events: Events,
    private alCtl: AlertController,
    private navParams: NavParams, 
    //private camera: Camera,
    private viewCtrl: ViewController,
    private toastCtrl: ToastController,
    private modalCtrl: ModalController,
  ) {
    this.newWhiskySelect = NewWhiskySelectPage;

    events.subscribe("select:distillery", item => {
      this.distillery = item.Distillery;
      this.region = item.Region;
      this.SWMS = item.SWMS
    });
    events.subscribe("select:bottler", item => {
      this.bottler = item;
    });

  }

  ionViewWillEnter() {
    this.ratings = WhiskyDB.ratings;
    this.shelves = WhiskyDB.getShelves();

    this.orig = this.navParams.get("whisky");
    if(this.orig == null ) { 
      console.log("new whisky");
      this.title = "New";
    } else {
      console.log("editing " + this.orig);
      this.title = "Edit";
      if(!this.select) {
        this.newName = this.orig.name;
        this.distillery = this.orig.distillery;
        this.region = this.orig.region;
        this.rating = this.orig.rating;
        this.SWMS = this.orig.SMWS;
        this.shelf1 = this.orig.shelves[0];
        this.shelf2 = this.orig.shelves[1];
        this.bottler = this.orig.bottler;
        this.image = null;
        if(this.orig.image === "yes")
        {
          WhiskyDB.db.loadImage(this.orig);
          this.events.subscribe("image:loaded", (image: string, name: string) => {
            if(this.orig.name === name)
              this.image = image;
          });
                
        }
        else this.image = null;
      }
    }
  }

  saveWhisky(event) {
    console.log("Save Whisky: " + this.newName);

    if (
      this.newName.length > 0 &&
      this.distillery.length > 0 &&
      this.rating.length > 0 
    ) {
    

      let whisky = new Whisky();
      whisky.distillery = this.distillery;
      whisky.region = this.region;
      whisky.SMWS = this.SWMS;
      whisky.bottler = this.bottler;
      whisky.name = this.newName;
      whisky.rating = this.rating;
      whisky.shelves = [this.shelf1, this.shelf2];
      if(this.image != null)
        whisky.image = "yes";

      let ts =  new Date().getTime();

      if(this.orig != null) 
      {
        // remove the original if editing
        console.log("Remove whisky for resave "  + this.orig.name);
        WhiskyDB.db.saveImage(this.orig, "", 0); // remove original image
        WhiskyDB.whisky = WhiskyDB.whisky.filter( w => { 
          return w.name !== this.orig.name;
        });
      }
      console.log("Adding whisky: " + whisky);
      if(this.image)
      {
        WhiskyDB.db.saveImage(whisky, this.image, ts);
        whisky.image = "yes";
      } else {
        whisky.image = null;
      }

      whisky.timestamp = new Date().getTime();
      console.log("timestamp: " + whisky.timestamp);

      WhiskyDB.whisky.push(whisky);
      WhiskyDB.db.saveWhisky();
      this.events.publish("whisky:updated");
      this.events.publish("whisky:saved", {whisky: whisky});
      this.navCtrl.pop();

      let toast = this.toastCtrl.create({
        message: whisky.name + ' was ' + ( this.orig != null ? 'updated' : 'added' ) + '.',
        duration: 3000
      });
      toast.present();
      
  
      return;
    }

    let alert = this.alCtl.create({
      title: "Unable to save",
      message:
        "Please ensure a name, distillery, rating and shelf have been selected before saving.",
      buttons: ["Dismiss"]
    });
    alert.present();
  }


/*  options: CameraOptions = {
    quality: 100,
    destinationType: this.camera.DestinationType.DATA_URL,
    encodingType: this.camera.EncodingType.JPEG,
    mediaType: this.camera.MediaType.PICTURE,
    targetWidth: 1000,
    targetHeight: 1500,
    //allowEdit: true,
    correctOrientation: true
  } */

  takePhoto()
  {
    Camera.getPhoto({ 
      quality: 90,
      allowEditing: true,
      resultType: CameraResultType.Base64
    }).then (
      (imageData) => {
      // imageData is either a base64 encoded string or a file URI
      // If it's base64:
      let base64Image = 'data:image/jpeg;base64,' + imageData.base64String;
      this.image = base64Image;
      this.imageChanged = true;

     }, (err) => {
       console.log("error getting photo " + err);
     });
     
  }

  deletePhoto()
  {
    this.image = null;
  }
 
  dismiss()
  {
    this.viewCtrl.dismiss();
  }
}



// WEBPACK FOOTER //
// ./src/pages/newWhisky/newWhisky.ts